import { t } from '@/utility/localization';

import NplToolTip from '@/components/common/NplToolTip';
import Icon from '@/components/npl/Icon';

export const SummarycardContainer = ({
  eyebrowIcon = false,
  eyebrow,
  title,
  tooltip,
  children,
  isLoading,
  isLrg = false,
  statusPillText,
  cardOnClick
}) => {
  if (isLoading) {
    return (
      <div className="h-[200px] w-full max-w-[300px] rounded-20 bg-npl-base-white p-20">
        <div className="mb-16 h-[18px] w-[150px] animate-pulse rounded-8 bg-npl-neutral-light-solid-5" />
        <div className="mb-16 h-[20px] w-[100px] animate-pulse rounded-8 bg-npl-neutral-light-solid-5" />
        <div className="mb-8 h-[16px] w-[150px] animate-pulse rounded-8 bg-npl-neutral-light-solid-5" />
        <div className="mb-8 h-[16px] w-[150px] animate-pulse rounded-8 bg-npl-neutral-light-solid-5" />
        <div className="mb-8 h-[16px] w-[150px] animate-pulse rounded-8 bg-npl-neutral-light-solid-5" />
      </div>
    );
  }
  return (
    <div
      className={`h-full  w-full rounded-20 border-1 relative overflow-hidden border-npl-neutral-light-solid-6 bg-npl-base-white p-24 ${
        (isLrg &&
          'col-span-1  md:col-span-2 md:min-w-[320px] min-w-[264px] lg:col-span-1',
        cardOnClick &&
          'hover:cursor-pointer hover:bg-npl-neutral-light-solid-2')
      }`}
      onClick={cardOnClick}>
      <div className="mb-8 flex flex-row items-center gap-8">
        {eyebrowIcon && (
          <Icon name={eyebrowIcon} width={20} fillOpacity={0.65} />
        )}
        <div className="text-label-md font-medium text-npl-text-icon-on-light-surface-secondary">
          {eyebrow}
        </div>
        {tooltip && (
          <div
            onClick={(event) => event.stopPropagation()}
            className="flex">
            <NplToolTip text={tooltip}>
              <Icon
                name="info-circle"
                width={16}
                height={16}
                fill="#91918D"
              />
            </NplToolTip>
          </div>
        )}
        <div>
          {statusPillText && (
            <div className="h-fit w-fit flex-shrink-0 rounded-4 border-1 border-npl-yellow-light-solid-6 bg-npl-yellow-light-solid-4 px-4 text-overline-xs font-semibold text-npl-yellow-light-solid-11">
              {t(statusPillText)}
            </div>
          )}
        </div>
      </div>
      <div className="mb-8 text-heading-lg font-semibold text-npl-text-icon-on-light-surface-primary last:mb-0 ">
        {title}
      </div>
      {children}
    </div>
  );
};
